var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CharacteristicSelectInline", {
    attrs: {
      value: _vm.value,
      "characteristic-items": _vm.meta.managementKind,
      "initial-show-all": "",
      "nothing-allowed": {
        text: "Nein"
      },
      "experience-config": {
        title: "Braucht man Erfahrung darin?",
        nothingAllowed: {
          enabled: false
        }
      },
      "with-experience": "",
      "suppress-items-info": "",
      "experience-selection-dropdown": "",
      "label-set": "customer",
      "label-type": "job-profile"
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }